import gql from 'graphql-tag';

export default gql`
  mutation ActivateAccount($token: String!) {
    auth {
      activateAccount(token: $token) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
